import { boardGameProducts } from '../Assets/Product_Info/boardGameProducts'
import { MTGProducts } from '../Assets/Product_Info/MTGProducts'
import { DiceProducts } from '../Assets/Product_Info/DiceProducts'
import { LuckDragonProducts } from '../Assets/Product_Info/LuckDragonProducts'
import { DragonShieldProducts } from '../Assets/Product_Info/DragonShieldProducts'
import { ArmyPainterProducts } from '../Assets/Product_Info/ArmyPainterProducts'
import { GradedGuardProducts } from '../Assets/Product_Info/GradedGuardProducts'
import { SleeveKingsProducts } from '../Assets/Product_Info/SleeveKingsProducts'
import { OnePieceProduct } from '../Assets/Product_Info/OnePieceProduct'
import { RiftboundProduct } from '../Assets/Product_Info/RiftboundProducts'


const productMap = {}
for (const p of boardGameProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of MTGProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of DiceProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of LuckDragonProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of DragonShieldProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of ArmyPainterProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of GradedGuardProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of SleeveKingsProducts) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of OnePieceProduct) productMap[p.id] = { ...p, link: `/Product/${p.id}` }
for (const p of RiftboundProduct) productMap[p.id] = { ...p, link: `/Product/${p.id}` }


export default productMap
